export enum PricingVariants {
  STANDARD = "standard",
  PREMIUM = "premium",
}
